<template>
	<div class="panel-header center">
		<div class="button-back caps z2 hide-print">
      <router-link :to="investigationLink" replace>Close</router-link>
    </div>
		<h3 class="caps">{{ title }}</h3>
	</div>
</template>

<script>
export default {

  name: 'PanelHeader',

  data () {
    return {

    }
  },

  computed: {
    investigationLink () {
      return {
        name: 'Investigation',
        params: {
          investigationSlug: this.$route.params.investigationSlug
        }
      }
    }
  },

  props: ['title']
}
</script>

<style lang="css" scoped>
	.panel-header {
		position: fixed;
		top: 0;
		left: 0;
		right: 0;
		background: var(--black);

		h3 {
			margin-top: 1em;
		}

		.button-back {
			left: 1em;

			a {
				color: var(--col-light);
			}
		}

		.top-right {
			right: 1em;
			position: fixed;
			top: 1em;
		}
	}
</style>
